import {
  Bus,
  Wrench,
  Smartphone,
  Route,
  LayoutDashboard,
  Plane,
  ArrowRight,
} from "lucide-react";

const services = [
  {
    icon: Bus,
    title: "Employee Cab Services",
    desc: "Daily scheduled pickups and drops for corporate employees with shift-based automation.",
  },
  {
    icon: Wrench,
    title: "Fleet Management",
    desc: "Quality-checked vehicles — Sedans, 6-Seaters, Toyota Innova Crysta — regularly maintained.",
  },
  {
    icon: Smartphone,
    title: "Technology Platform",
    desc: "Web + mobile app for booking, real-time tracking, and billing.",
  },
  {
    icon: Route,
    title: "Automated Route Allocation",
    desc: "Smart cab scheduling based on employee shift data — no manual coordination.",
  },
  {
    icon: LayoutDashboard,
    title: "Corporate Dashboard",
    desc: "Admin and finance teams can book, track, and view bills in one place.",
  },
  {
    icon: Plane,
    title: "Airport & Hotel Transfers",
    desc: "Point-to-point premium transfers for executives and guests.",
  },
];

export default function Services() {
  return (
    <section id="services" className="section-pad bg-[#f6f7fb]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <div className="eyebrow mb-4">Our Services</div>
          <h2 className="headline text-[34px] md:text-[44px]" data-testid="services-headline">
            Built end-to-end for the way modern companies move.
          </h2>
          <p className="mt-5 text-[16px] md:text-[17px] text-slate-600 leading-relaxed">
            From daily employee shuttles to executive airport transfers — Rydey handles
            every layer of corporate transportation with technology, accountability, and
            zero coordination overhead.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <ServiceCard key={s.title} {...s} delay={i * 0.06} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ icon: Icon, title, desc, delay }) {
  return (
    <div
      data-testid={`service-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group relative bg-white p-7 rounded-2xl border border-slate-200 card-elevate reveal"
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className="w-14 h-14 rounded-xl bg-[#0D1B40] text-[#F5A623] flex items-center justify-center mb-5 group-hover:bg-[#F5A623] group-hover:text-[#0D1B40] transition-colors duration-300">
        <Icon size={26} />
      </div>
      <h3 className="text-[#0D1B40] font-bold text-[19px] mb-3 leading-snug">{title}</h3>
      <p className="text-slate-600 text-[15px] leading-relaxed">{desc}</p>
      <div className="mt-5 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#0D1B40] opacity-0 group-hover:opacity-100 transition-opacity">
        Learn more <ArrowRight size={14} />
      </div>
    </div>
  );
}
